<template>
	<div class="detail-form">
		<div class="row" v-show="!isLoadingOperations">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="name">Nome do Tipo de Operação: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.name ? 'alert' : '']"
					id="name"
					type="text"
					placeholder="Nome do Tipo de Operação"
					v-model="operation.name"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.name">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="PT-BR"
					value="PT-BR"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingOperations">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="secondName">Nome do Tipo de Operação: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.secondName ? 'alert' : '']"
					id="secondName"
					type="text"
					placeholder="Nome do Tipo de Operação"
					v-model="operation.secondName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.secondName">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="EN-US"
					value="EN-US"
				/>
			</div>
		</div>
		<div
			class="detail-form__actions"
			:class="newOperation ? 'new-operation' : ''"
			v-show="!isLoadingOperations"
		>
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newOperation"
			>
				Excluir Tipo de Operação
			</button>
			<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingOperations">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Tipo de Operação'"
			:subtitle="'Tem certeza que deseja excluir este tipo de operação?'"
			:loader="isLoadingOperations"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_OPERATION_BY_ID,
	CREATE_OPERATION,
	UPDATE_OPERATION,
	DELETE_OPERATION,
} from '@/store/modules/operationTypeManagement/actions';
import { mask } from 'vue-the-mask';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';

export default {
	name: 'OperationTypeForm',
	directives: { mask },
	components: { GenericMultiselect, SpinnerIcon, DeleteModal },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		operation: {
			name: '',
			secondName: '',
		},
		requiredFields: {
			name: false,
			secondName: false,
		},
		newOperation: false,
		isEditing: false,
		showDeleteModal: false,
	}),
	created() {},
	mounted() {
		if (this.$route.query.id) {
			this.getOperation({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedOperation = res.data;

				selectedOperation.forEach((item) => {
					if (item.language == 'pt-br') this.operation.name = item.name;
					if (item.language == 'en-us') this.operation.secondName = item.name;
				});
			});
		} else {
			this.newOperation = true;
		}
	},
	methods: {
		...mapActions('operationTypeManagement', {
			getOperation: GET_OPERATION_BY_ID,
			createNewOperation: CREATE_OPERATION,
			updateOperation: UPDATE_OPERATION,
			deleteOperation: DELETE_OPERATION,
		}),
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteOperation({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/config/operationType' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		createOperation() {
			const body = { itens: [] };

			body.itens.push(
				{ name: this.operation.name, language: 'pt-br' },
				{ name: this.operation.secondName, language: 'en-us' },
			);

			this.createNewOperation({ vm: this, body: body }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/config/operationType' });
				}
			});
		},
		confirmUpdate() {
			const body = { itens: [] };

			body.itens.push(
				{ name: this.operation.name, language: 'pt-br' },
				{ name: this.operation.secondName, language: 'en-us' },
			);

			this.updateOperation({ vm: this, id: this.$route.query.id, body: body }).then((res) => {
				if (res.status == 200) {
					this.isEditing = false;
				}
			});
		},
		validateFields() {
			this.requiredFields = {
				name: true,
				secondName: true,
			};

			if (this.operation.name) this.requiredFields.name = false;
			if (this.operation.secondName) this.requiredFields.secondName = false;

			if (!this.operation.name || !this.operation.secondName) {
				return;
			}

			if (!this.newOperation) {
				this.confirmUpdate();
			} else {
				this.createOperation();
			}
		},
	},
	computed: {
		...mapGetters('operationTypeManagement', ['isLoadingOperations']),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OperationTypeForm.scss';
</style>
